import { render, staticRenderFns } from "./userAddOrUpdate.vue?vue&type=template&id=1e680b2b&scoped=true&"
import script from "./userAddOrUpdate.vue?vue&type=script&lang=js&"
export * from "./userAddOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e680b2b",
  null
  
)

export default component.exports